import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  Checkbox,
  FormControlLabel,
  Snackbar,
  Grid,
} from "@mui/material";
// import useCourseCatalog from "../hooks/CourseCatalogHook"; // Replace with useFirestore
import useFirestore from "../../../../config/fireBaseHook"; // Import the useFirestore hook
import { TpCreditTypeDropdown } from "../DropDowns";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const Add = () => {
  const { addData } = useFirestore("TpCourseCatalog"); // Use useFirestore and get addData for the collection
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [formData, setFormData] = useState({
    Course: "",
    Subject: "",
    Lab_Type_Course: 0,
    Credit_Type: "",
    Credits: "",
    Ode_Course: "",
    Ode_Subject_Code: "",
    TP_Pathway: "",
    Ode_Program: "",
    Ode_Program_Code: "",
    TP_Pthwy_abv: "",
    School_Year_Active: "",
    Shell_Option: 0,
    Course_And_Subject: "",
    Internal_Note: "",
    External_Note: "",
    Pilot_Note: "",
    Pilot: 0,
    New: 0,
    credit_capture_scheme: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked ? -1 : 0,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await addData(formData); // Use addData from useFirestore
      setLoading(false);
      setSnackbarOpen(true);
      setFormData({
        Course: "",
        Subject: "",
        Lab_Type_Course: 0,
        Credit_Type: "",
        Credits: "",
        Ode_Course: "",
        Ode_Subject_Code: "",
        TP_Pathway: "",
        Ode_Program: "",
        Ode_Program_Code: "",
        TP_Pthwy_abv: "",
        School_Year_Active: "",
        Shell_Option: 0,
        Course_And_Subject: "",
        Internal_Note: "",
        External_Note: "",
        Pilot_Note: "",
        Pilot: 0,
        New: 0,
        credit_capture_scheme: "",
      });
      setOpen(false);
    } catch (error) {
      console.error("Error adding record:", error);
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="success"
        onClick={() => setOpen(true)}
        sx={{ marginBottom: "10px", color: "white" }}
      >
        Add Record
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <ModalDialogTitle onClose={() => setOpen(false)}>
          Add Record
        </ModalDialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Course"
                name="Course"
                value={formData.Course}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Subject"
                name="Subject"
                value={formData.Subject}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TpCreditTypeDropdown
                value={formData.Credit_Type}
                onChange={handleChange}
                name="Credit_Type"
                label="Credit Type"
                fullWidth
                margin="normal"
              />
              <TextField
                label="Credits"
                name="Credits"
                value={formData.Credits}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Ode Course"
                name="Ode_Course"
                value={formData.Ode_Course}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Ode Subject Code"
                name="Ode_Subject_Code"
                value={formData.Ode_Subject_Code}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="TP Pathway"
                name="TP_Pathway"
                value={formData.TP_Pathway}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Ode Program"
                name="Ode_Program"
                value={formData.Ode_Program}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Ode Program Code"
                name="Ode_Program_Code"
                value={formData.Ode_Program_Code}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="TP Pthwy abv"
                name="TP_Pthwy_abv"
                value={formData.TP_Pthwy_abv}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="School Year Active"
                name="School_Year_Active"
                value={formData.School_Year_Active}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Course And Subject"
                name="Course_And_Subject"
                value={formData.Course_And_Subject}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Internal Note"
                name="Internal_Note"
                value={formData.Internal_Note}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="External Note"
                name="External_Note"
                value={formData.External_Note}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Pilot Note"
                name="Pilot_Note"
                value={formData.Pilot_Note}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Credit Capture Scheme"
                name="credit_capture_scheme"
                value={formData.credit_capture_scheme}
                onChange={handleChange}
                fullWidth
                margin="normal"
                multiline
                rows={4}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.Lab_Type_Course === -1}
                    onChange={handleCheckboxChange}
                    name="Lab_Type_Course"
                  />
                }
                label="Lab Type Course"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.Shell_Option === -1}
                    onChange={handleCheckboxChange}
                    name="Shell_Option"
                  />
                }
                label="Shell Option"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.Pilot === -1}
                    onChange={handleCheckboxChange}
                    name="Pilot"
                  />
                }
                label="Pilot"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.New === -1}
                    onChange={handleCheckboxChange}
                    name="New"
                  />
                }
                label="New"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="Record has been added"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        ContentProps={{
          sx: {
            backgroundColor: "black",
            color: "white",
          },
        }}
      />
    </div>
  );
};

export default Add;
